/**
 * Retrieves a value from a nested object structure given a type and an ID.
 * Assumes a structure like obj[type][id].
 *
 * @param {Object} obj - The object to retrieve the value from.
 * @param {string} type - The first level key (e.g., 'elevation', 'speed').
 * @param {string} id - The second level key (e.g., 'ascent', 'average').
 * @returns {*} The retrieved value, or undefined if not found.
 */
export const getNestedValue = (obj, type, id) => {
  if (!obj || typeof obj !== 'object') {
    return undefined;
  }

  if (obj[type] && obj[type][id] !== undefined) {
    return obj[type][id];
  }

  return undefined;
};
